import {WlDropDownButtons} from "./dropdownButtons.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './dropdownButtons.component';
export default WlDropDownButtons;

defineWebComponent('wl-dropdown-buttons', WlDropDownButtons);